import { Box, Stack } from '@mui/material';
import { hasPermission } from 'components/AuthorizationComponent';
import { TextInput } from 'components/Inputs';
import { SelectList } from 'components/SelectList';
import { searchTypeEnum } from 'constants/dashboard.constants';
import { permissionEnums } from 'constants/permission.constants';
import { useAppDispatch, useAppSelector } from 'hooks/redux.hooks';
import { useEffect, useMemo, useState } from 'react';
import { getSearchMatches } from 'services/dashboard.service';
import { getSearchResults, setSearchResults } from 'state/reducers/dashboard.reducer';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { SearchResults } from './SearchResults';
import { useNavigate } from 'react-router-dom';
import { pagesEnum } from 'constants/ui.constants';
import { isHebrewWord } from 'utils/index';
import { customerAccountDetailsTypes } from 'constants/customer-account.constants';

export const SearchComponent = () => {
	const dispatch = useAppDispatch();
	const t = useAppSelector(selectTranslations);
	const navigate = useNavigate();
	const pagePrefix = 'page.dashboard.search.';
	const searchOptions = [
		{ value: searchTypeEnum.COMPANY_NAME, name: t(`${pagePrefix}type.company`) },
		{ value: searchTypeEnum.CONTACT, name: t(`${pagePrefix}type.contact`) },
		{ value: searchTypeEnum.OPEN_ACCOUNT, name: t(`${pagePrefix}type.openAccount`) },
		{ value: searchTypeEnum.HYPER_ACCOUNT, name: t(`${pagePrefix}type.hyperAccount`) },
		{ value: searchTypeEnum.CC_ACCOUNT, name: t(`${pagePrefix}type.ccAccount`) },
	];
	const [searchType, setSearchType] = useState<any>(searchOptions[0]);
	const [searchInput, setSearchInput] = useState<any>('');
	const searchPermission = hasPermission([permissionEnums.FREE_TEXT_SEARCH_DATABASE]);
	const searchResults = useAppSelector(getSearchResults);

	useEffect(() => {
		if (searchInput?.length >= 2 && searchPermission) {
			dispatch(getSearchMatches({ searchWord: searchInput, searchType: searchType.value }));
		}
	}, [searchInput]);

	const handleResultClick = (item: any, company: any) => {
		setSearchInput('');
		if (searchType.value === searchTypeEnum.CONTACT) {
			navigate(
				`/${pagesEnum.CUSTOMER_ACCOUNTS_DETAILS}/${company?.company?.id}/${customerAccountDetailsTypes.CONTACTS}/${item.id}`
			);
		} else {
			navigate(`/${pagesEnum.CUSTOMER_ACCOUNTS}/${item.id}`);
		}
	};

	const isHebrewTerm = useMemo(() => isHebrewWord(searchInput), [searchInput]);

	return (
		<Stack sx={{ width: '100%' }}>
			<Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 2, md: 3 }}>
				<SelectList
					options={searchOptions}
					selected={searchType}
					handleChange={(event: any) => {
						dispatch(setSearchResults(null));
						setSearchInput('');
						setSearchType(searchOptions.filter((item) => item.value === event.target.value)[0]);
					}}
					styleObj={{ width: '188px', height: '40px' }}
				/>
				<Box
					sx={{
						position: 'relative',
						minWidth: '300px',
						'& .MuiOutlinedInput-notchedOutline': { borderRadius: '4px!important' },
					}}
				>
					<TextInput
						textFieldStyle={{
							'& .MuiOutlinedInput-root.Mui-focused img': {
								opacity: '1!important',
								filter: 'saturate(1)!important',
							},
						}}
						value={searchInput}
						placeholder={t(`${pagePrefix}searchInput.placeholder`)}
						onChange={(event: any) => setSearchInput(event)}
						icon={
							<img
								src="/icons/search-2.svg"
								style={{
									position: 'absolute',
									margin: 0,
									top: '50%',
									right: '5px',
									transform: 'translate(0, -50%)',
									opacity: 0.5,
									filter: 'saturate(0.5)',
								}}
							/>
						}
					/>
					{searchInput.length >= 2 && (
						<SearchResults
							searchResults={searchResults}
							searchType={searchType.value}
							handleClick={handleResultClick}
							isHebrewTerm={isHebrewTerm}
						/>
					)}
				</Box>
			</Stack>
		</Stack>
	);
};
